(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ui"] = factory();
	else
		root["ui"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(25);
	
	var Top = __webpack_require__(7);
	
	module.exports = { Top: Top };

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    /**
	     * Attach analytics events
	     */
	    var analytics = {
	
	        /**
	         * @description ensure that element(s) passed are in array format for iteration in bind method
	         * @param el
	         * @returns {Array}
	         */
	        normaliseElements: function normaliseElements(el) {
	            if (!el) {
	                return [];
	            }
	            if (Array.isArray(el)) {
	                return el;
	            }
	            if (!el.length && !Array.isArray(el)) {
	                el = [el];
	            }
	            return el;
	        },
	        /**
	         * @description add event listeners and associated data for event
	         * @param el {Object}
	         * @param actions {Object}
	         */
	        bind: function bind(el, actions) {
	            var elements = analytics.normaliseElements(el);
	
	            for (var iItem = 0; iItem < elements.length; iItem++) {
	                var elItem = elements[iItem];
	                if (!elItem.nodeName) {
	                    throw new Error('element is not a DOM object');
	                }
	                for (var iAction = 0; iAction < actions.length; iAction++) {
	                    var action = actions[iAction];
	                    var data = action.data ? [action.data] : [elItem];
	                    elItem.addEventListener(action.event, analytics.send(action.functionName, data));
	                }
	            }
	        },
	        /**
	         * @description event listener function
	         * @param functionName {String}
	         * @param data {Object}
	         * @returns {Function}
	         */
	        send: function send(functionName, data) {
	            return function () {
	                try {
	                    if (window[functionName]) {
	                        window[functionName].apply(null, data);
	                    }
	                } catch (e) {
	                    throw new Error(e.stack);
	                }
	            };
	        }
	    };
	
	    return analytics;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var utils = {
	        hasTouchCapability: function hasTouchCapability() {
	            return document.querySelector('html.touch') !== null;
	        },
	
	        preventClick: function preventClick(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            return false;
	        },
	
	        hasClass: function hasClass(element, className) {
	            return new RegExp(' ' + className + ' ').test(' ' + element.className + ' ');
	        },
	
	        addClass: function addClass(element, className) {
	            var hasClass = utils.hasClass(element, className);
	            if (!hasClass) {
	                element.className += ' ' + className;
	            }
	        },
	
	        removeClass: function removeClass(element, className) {
	            var hasClass = utils.hasClass(element, className);
	            if (hasClass) {
	                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
	                element.className = element.className.replace(reg, ' ');
	            }
	        },
	
	        /**
	         * @param {Object} obj key values to construct string
	         * @returns {string/Boolean}
	         */
	        serialize: function serialize(obj) {
	            var str = [];
	
	            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || Array.isArray(obj)) {
	                return false;
	            }
	
	            for (var p in obj) {
	                if (obj.hasOwnProperty(p)) {
	                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	                }
	            }
	
	            return str.join('&');
	        },
	
	        /**
	         * @param host {string}
	         * @param params {object}
	         * @returns {string}
	         */
	        constructUrl: function constructUrl(host, params) {
	            var parts = [];
	
	            if (typeof host !== 'string') {
	                return '';
	            }
	
	            parts.push(host);
	
	            if (utils.serialize(params)) {
	                parts.push(utils.serialize(params));
	            }
	
	            return parts.join('?');
	        },
	
	        /**
	         * Append the current url to the target url
	         * @param {String} targetUrl
	         * @param {String} sourceUrl
	         * @returns {String}
	         */
	        appendSourceUrl: function appendSourceUrl(targetUrl, sourceUrl) {
	            if (typeof targetUrl !== 'string' || typeof sourceUrl !== 'string') {
	                return '/';
	            }
	            if (targetUrl.indexOf('sourceurl') === -1) {
	                sourceUrl = decodeURIComponent(sourceUrl);
	                if (targetUrl.indexOf('?') === -1) {
	                    targetUrl += '?';
	                } else {
	                    if (targetUrl.indexOf('?') !== targetUrl.length - 1) {
	                        targetUrl += '&';
	                    }
	                }
	                return targetUrl + 'sourceurl=' + encodeURIComponent(sourceUrl);
	            } else {
	                return targetUrl;
	            }
	        },
	
	        /**
	         * Set a group of DOM elements' tabindex
	         * @param {DOM object} els
	         * @param {Integer} tabindex
	         */
	        setTabIndex: function setTabIndex(els, tabindex) {
	            for (var i = 0; i < els.length; i++) {
	                els[i].setAttribute('tabindex', tabindex);
	            }
	        }
	
	    };
	
	    return utils;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	if (typeof window !== 'undefined' && typeof window.mnsFooterConfig !== 'undefined') {
	    module.exports = window.mnsFooterConfig;
	} else {
	    module.exports = {
	        "wcsBaseUrl": "/webapp/wcs/stores/servlet/",
	        "CMD": {
	            "contentAPI": "MSResFetchContentAjax"
	        },
	        "storeId": "10151",
	        "langId": "-24",
	        "catalogId": "10051"
	    };
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(19).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).setImmediate, __webpack_require__(4).clearImmediate))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var constant = {
	        ukId: '10151',
	        ieId: '10451',
	        currencyUk: '£',
	        currencyIe: '€'
	    };
	    return constant;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(21), __webpack_require__(3), __webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XhrPromise, config, util, analytics) {
	
	    return {
	
	        initOverlay: function initOverlay() {
	            this.waysToPayOverlayLinks = document.querySelectorAll('.navfooter-stclinks[href="javascript:;"]');
	            this.overlayPanel = document.querySelector('.navfooter-overlay');
	            this.backgroundOverlayVeil = document.querySelector('.navfooter-background--overlay');
	            this.overlayClose = document.querySelector('.navfooter-overlay--close');
	            this.bodyEL = document.querySelector('body');
	            this.htmlEL = document.querySelector('html');
	            this.closeTabs = document.querySelectorAll('.navfooter-overlay-backtab');
	            this.lazyloadDiv = document.querySelector('.navfooter-lazyload');
	            this.openOverlay = this.openOverlay.bind(this);
	            this.openOverlayKeyup = this.openOverlayKeyup.bind(this);
	            this.loadOverlayData = this.loadOverlayData.bind(this);
	            this.loadOverlayDom = this.loadOverlayDom.bind(this);
	            this.closeOverlay = this.closeOverlay.bind(this);
	            this.dontCloseOverlayKeyup = this.dontCloseOverlayKeyup.bind(this);
	            this.closeOverlayEnter = this.closeOverlayEnter.bind(this);
	            this.closeOverlayKeyup = this.closeOverlayKeyup.bind(this);
	            for (var iterator = 0; iterator < this.waysToPayOverlayLinks.length; iterator++) {
	                this.waysToPayOverlayLinks[iterator].addEventListener('click', this.openOverlay);
	                this.waysToPayOverlayLinks[iterator].addEventListener('keyup', this.openOverlayKeyup);
	
	                analytics.bind(this.waysToPayOverlayLinks[iterator], [{
	                    functionName: 'analyticsFooterFlyout',
	                    event: 'click',
	                    data: this.waysToPayOverlayLinks[iterator].title
	                }]);
	            }
	            this.overlayClose.addEventListener('click', this.closeOverlay);
	            this.overlayClose.addEventListener('keyup', this.closeOverlayEnter);
	            this.backgroundOverlayVeil.addEventListener('click', this.closeOverlay);
	            this.overlayPanel.addEventListener('keyup', this.closeOverlayKeyup);
	            this.closeTabs[0].addEventListener('keyup', this.dontCloseOverlayKeyup);
	            this.closeTabs[1].addEventListener('keyup', this.dontCloseOverlayKeyup);
	        },
	        loadOverlayDom: function loadOverlayDom(overlayData) {
	            if (this.id && !window[this.id]) {
	                window[this.id] = overlayData;
	                document.querySelector('.navfooter-lazyload').style.display = 'none';
	            }
	            var overlayDOM = document.querySelector('.navfooter-overlay--content');
	            overlayDOM.innerHTML = overlayData;
	        },
	
	        loadOverlayData: function loadOverlayData(callback) {
	            var xhrp = new XhrPromise();
	
	            xhrp.send({
	                url: config.wcsBaseUrl + config.CMD.contentAPI + '?contentId=' + this.id + '&catalogId=' + config.catalogId + '&langId=' + config.langId + '&storeId=' + config.storeId,
	                method: 'GET'
	            }).then(function (response) {
	                if (response.status === 200) {
	                    callback(response.responseText);
	                }
	            }).catch(function () {
	                //Handle errors here
	                callback([]);
	            });
	        },
	
	        openOverlay: function openOverlay(event) {
	            this.target = event.currentTarget;
	            this.id = event.currentTarget.getAttribute('data-content-id');
	            if (this.id && window[this.id]) {
	                this.loadOverlayDom(window[this.id]);
	            } else {
	                this.lazyloadDiv.style.display = 'block';
	                this.loadOverlayData(this.loadOverlayDom);
	            }
	            util.addClass(this.overlayPanel, 'navfooter-overlay--visible');
	            this.overlayPanel.style.visibility = 'visible';
	            this.backgroundOverlayVeil.style.visibility = 'visible';
	            util.addClass(this.backgroundOverlayVeil, 'navfooter-background--overlay-visible');
	            util.addClass(this.bodyEL, 'navfooter-prevent-scrolling');
	            util.addClass(this.htmlEL, 'navfooter-prevent-scrolling');
	            this.closeTabs[0].style.display = 'block';
	            this.closeTabs[1].style.display = 'block';
	            this.overlayPanel.focus();
	        },
	
	        openOverlayKeyup: function openOverlayKeyup(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 'Enter' || keyPressed === 13) {
	                this.openOverlay(event);
	            }
	        },
	
	        closeOverlay: function closeOverlay(event) {
	            util.removeClass(this.overlayPanel, 'navfooter-overlay--visible');
	            util.removeClass(this.backgroundOverlayVeil, 'navfooter-background--overlay-visible');
	            util.removeClass(this.bodyEL, 'navfooter-prevent-scrolling');
	            util.removeClass(this.htmlEL, 'navfooter-prevent-scrolling');
	            setTimeout(function () {
	                this.overlayPanel.style.visibility = 'hidden';
	                this.backgroundOverlayVeil.style.visibility = 'hidden';
	                var overlayDOM = document.querySelector('.navfooter-overlay--content');
	                overlayDOM.innerHTML = '';
	            }.bind(this), 500);
	            if (event.key && (event.key === 'Enter' || event.key === 'Escape')) {
	                this.target.focus();
	            }
	            this.closeTabs[0].style.display = 'none';
	            this.closeTabs[1].style.display = 'none';
	        },
	
	        closeOverlayKeyup: function closeOverlayKeyup(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 27 || keyPressed === 'Escape') {
	                this.closeOverlay(event);
	            }
	        },
	
	        closeOverlayEnter: function closeOverlayEnter(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 'Enter' || keyPressed === 13) {
	                this.closeOverlay(event);
	            }
	        },
	
	        dontCloseOverlayKeyup: function dontCloseOverlayKeyup() {
	            this.overlayClose.focus();
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12), __webpack_require__(6), __webpack_require__(13), __webpack_require__(8), __webpack_require__(11), __webpack_require__(14), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (NewsLettercomponent, FooterOverlay, PageSpecificComponent, LazyloadImage, mnsCookieService, RecentlyViewedComponent, BrandNewsletterComponent) {
	
	    function Footer() {
	        new NewsLettercomponent();
	        new PageSpecificComponent();
	        new BrandNewsletterComponent();
	        FooterOverlay.initOverlay();
	        LazyloadImage.init();
	        var sessionStorage = window.sessionStorage;
	        var textlinkheadings = document.querySelectorAll('.navfooter-textlinks__heading');
	        var panel = document.querySelectorAll('.navfooter-footerlinkslist'),
	            i,
	            j;
	        if (window.innerWidth < '768') {
	            for (i = 0; i < textlinkheadings.length; i++) {
	                textlinkheadings[i].addEventListener('click', togglefunction);
	                textlinkheadings[i].addEventListener('keydown', togglefunction);
	                panel[i].addEventListener('keydown', togglefunction);
	                textlinkheadings[i].setAttribute('role', 'button');
	                textlinkheadings[i].removeAttribute('aria-level');
	            }
	        } else {
	            for (i = 0; i < textlinkheadings.length; i++) {
	                textlinkheadings[i].setAttribute('role', 'heading');
	                textlinkheadings[i].setAttribute('aria-level', '2');
	            }
	        }
	        function togglefunction(evt) {
	            var keyPressed = evt.key || evt.keyCode || evt.type;
	            switch (keyPressed) {
	                case 'Enter':
	                case 'click':
	                    if (evt.target.classList.contains('navfooter-textlinks__heading')) {
	                        evt.preventDefault();
	                        var setClasses = !evt.target.classList.contains('active');
	                        setClass(textlinkheadings, 'active', 'remove');
	                        setClass(panel, 'nav-footer-accordian', 'remove');
	                        if (setClasses) {
	                            evt.target.classList.toggle('active');
	                            evt.srcElement.nextElementSibling.classList.toggle('nav-footer-accordian');
	                            evt.target.setAttribute('aria-expanded', 'true');
	                        }
	                    }
	                    if (keyPressed === 'click') {
	                        setblur(textlinkheadings);
	                    }
	                    break;
	
	                case 'Home':
	                case '36':
	                    evt.preventDefault();
	                    document.querySelector('.navfooter-textlinks__heading').focus();
	                    break;
	
	                case 'End':
	                case '35':
	                    evt.preventDefault();
	                    textlinkheadings[textlinkheadings.length - 1].focus();
	                    break;
	
	                case 'Escape':
	                case 'Esc':
	                case '27':
	                    if (!evt.target.classList.contains('navfooter-textlinks__heading')) {
	                        evt.srcElement.parentNode.parentNode.previousElementSibling.classList.remove('active');
	                        evt.srcElement.parentNode.parentNode.classList.remove('nav-footer-accordian');
	                        evt.srcElement.parentNode.parentNode.previousElementSibling.focus();
	                        evt.srcElement.parentNode.parentNode.previousElementSibling.setAttribute('aria-expanded', 'false');
	                    }
	                    break;
	            }
	        }
	
	        function setClass(els, className, fnName) {
	            for (var i = 0; i < els.length; i++) {
	                els[i].classList[fnName](className);
	                if (els[i].classList.contains('navfooter-textlinks__heading')) {
	                    els[i].setAttribute('aria-expanded', 'false');
	                }
	            }
	        }
	        function setblur(element) {
	            for (var i = 0; i < element.length; i++) {
	                element[i].blur();
	            }
	        }
	        window.addEventListener('resize', onResizeEvent);
	
	        function onResizeEvent() {
	            if (window.innerWidth < '768') {
	                for (i = 0; i < textlinkheadings.length; i++) {
	                    textlinkheadings[i].addEventListener('click', togglefunction);
	                    textlinkheadings[i].addEventListener('keydown', togglefunction);
	                    panel[i].addEventListener('keydown', togglefunction);
	                    textlinkheadings[i].setAttribute('role', 'button');
	                    textlinkheadings[i].removeAttribute('aria-level');
	                }
	            } else {
	                for (i = 0; i < textlinkheadings.length; i++) {
	                    textlinkheadings[i].removeEventListener('click', togglefunction);
	                    textlinkheadings[i].removeEventListener('keydown', togglefunction);
	                    panel[i].removeEventListener('keydown', togglefunction);
	                    textlinkheadings[i].setAttribute('role', 'heading');
	                    textlinkheadings[i].setAttribute('aria-level', '2');
	                }
	            }
	            var slideproductItem = document.querySelectorAll('.navfooter-desktopcarousel__slide-productitem');
	            var slideProductWrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
	            if ('1280' <= window.innerWidth && window.innerWidth < '1920' && slideproductItem && slideProductWrapper) {
	                for (j = 0; j < slideproductItem.length; j++) {
	                    slideproductItem[j].style.width = (slideProductWrapper.offsetWidth - 112) / 6 + 'px';
	                }
	            } else if (('1280' > window.innerWidth || window.innerWidth > '1920') && slideproductItem && slideProductWrapper) {
	                for (j = 0; j < slideproductItem.length; j++) {
	                    slideproductItem[j].style.width = 'auto';
	                }
	            }
	        }
	
	        window.addEventListener('scroll', listenScrollEvent);
	
	        function listenScrollEvent() {
	            var footerPosition = window.scrollY + window.innerHeight;
	            var bodyHeight = document.body.offsetHeight - 1300;
	            if (footerPosition > window.innerHeight && footerPosition > bodyHeight) {
	                sessionStorage.setItem('pageScrolledTillBottom', 'true');
	            } else {
	                var data = sessionStorage.getItem('pageScrolledTillBottom');
	                if (data) {
	                    sessionStorage.removeItem('pageScrolledTillBottom');
	                }
	            }
	        }
	
	        if (window.sessionStorage && sessionStorage.getItem('pageScrolledTillBottom')) {
	            this.imageList = document.querySelectorAll('#navigation-commonfooter img[data-src]');
	            this.imageSrcList = document.querySelectorAll('#navigation-commonfooter img[src]');
	            this.imagesrclistLength = this.imageSrcList.length;
	            if (this.imageList && this.imagesrclistLength === 0) {
	                for (var iImage = 0; iImage < this.imageList.length; iImage++) {
	                    this.imageList[iImage].src = this.imageList[iImage].attributes['data-src'].value;
	                }
	            }
	        }
	        var newsLetterElement = document.getElementById('newsLetterComponentEnable');
	        if (mnsCookieService.isUserLoggedIn() && newsLetterElement) {
	            newsLetterElement.style.display = 'none';
	        }
	
	        /* Recently viewed Item code*/
	        var recentlyviewContainer = document.querySelector('.navfooter-recentlyviewContainer');
	
	        if (recentlyviewContainer) {
	            new RecentlyViewedComponent();
	        }
	        /* providing display none to footer in mobile app web view pages*/
	        var platformCookie = document.cookie.match('platform');
	        var commonfooterSection = document.getElementById('navigation-commonfooter');
	        if (platformCookie !== null && platformCookie.input && commonfooterSection) {
	            platformCookie.input.indexOf('mobileapp') !== -1 ? commonfooterSection.style.display = 'none' : false;
	        }
	
	        var dcpplusElement = document.querySelector('.dot-com-plus-menu');
	        var copyRigtSection = document.querySelector('.navfooter-legallinkscontainer-legaldiv');
	        if (dcpplusElement) {
	            copyRigtSection.classList.add('navigation-storespecificclass');
	        }
	
	        function newsLetterHandler(path) {
	            var brandNewsletterElement = document.getElementById('brandNewsLetterComponentEnable');
	            var newsLetterElement = document.getElementById('newsLetterComponentEnable');
	            var key = 'jaeger';
	            var brand = document.querySelector('.product-info__brand');
	            if (newsLetterElement && (path.indexOf(key) !== -1 || brand && brand.textContent.toLowerCase() === key)) {
	                brandNewsletterElement.style.display = 'block';
	                brandNewsletterElement.classList.add('bg-image__show');
	                newsLetterElement.style.display = 'none';
	            } else if (brandNewsletterElement) {
	                brandNewsletterElement.style.display = 'none';
	                brandNewsletterElement.classList.remove('bg_image__show');
	                if (mnsCookieService.isUserLoggedIn() && newsLetterElement) {
	                    newsLetterElement.style.display = 'none';
	                } else {
	                    newsLetterElement.style.display = 'block';
	                }
	            }
	        }
	
	        var path = window.location.pathname;
	        newsLetterHandler(path);
	        document.querySelector('body').addEventListener('click', function (event) {
	            if (event.target.tagName.toLowerCase() === 'a' && !event.target.href.includes('javascript:')) {
	                path = event.target.href ? event.target.href : false;
	                if (path) {
	                    newsLetterHandler(path);
	                }
	            }
	        });
	        window.addEventListener('popstate', function () {
	            newsLetterHandler(window.location.href);
	        });
	    }
	    return Footer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    return {
	
	        init: function init() {
	            var waystopayElement = document.querySelector('.navfooter-waystopaytext');
	            var socialmediaElement = document.querySelector('.navfooter-socialmedialinks__container');
	            this.swapImagedatasrc = this.swapImagedatasrc.bind(this);
	            this.isImageVisible = this.isImageVisible.bind(this);
	            if (waystopayElement) {
	                this.isImageVisible(waystopayElement) ? window.addEventListener('load', this.swapImagedatasrc) : window.addEventListener('scroll', this.swapImagedatasrc);
	            } else {
	                if (socialmediaElement) {
	                    this.isImageVisible(socialmediaElement) ? window.addEventListener('load', this.swapImagedatasrc) : window.addEventListener('scroll', this.swapImagedatasrc);
	                }
	            }
	        },
	        swapImagedatasrc: function swapImagedatasrc() {
	            if (document.readyState === 'complete') {
	                this.imageList = document.querySelectorAll('#navigation-commonfooter img[data-src]');
	                this.imageSrcList = document.querySelectorAll('#navigation-commonfooter img[src]');
	                this.imagesrclistLength = this.imageSrcList.length;
	                if (this.imageList) {
	                    for (var iImage = 0; iImage < this.imageList.length; iImage++) {
	                        this.imageList[iImage].src = this.imageList[iImage].attributes['data-src'].value;
	                        this.imageList[iImage].parentElement.classList.contains('lazyloadfooterimage') ? this.imageList[iImage].parentElement.classList.remove('lazyloadfooterimage') : false;
	                    }
	                }
	            }
	        },
	
	        isImageVisible: function isImageVisible(el) {
	            var rect = el.getBoundingClientRect();
	            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, analytics) {
	
	    function brandNewslettercomponent() {
	        this.inputFieldElement = document.querySelector('.navfooter-brand-newsletter-signup__form__input');
	        this.emailErrormsg = document.querySelector('.navfooter-brand-newsletter-signup-errormsg');
	        this.alertIcon = document.querySelector('.navfooter-brand-newsletter-signup-alerticon.navfooter-alertdiv');
	        this.emailSubmitButton = document.querySelector('.navfooter-brand-newsletter-signup__form__submit');
	        this.validateInputField = this.validateInputField.bind(this);
	        this.validateInputFieldOnFocus = this.validateInputFieldOnFocus.bind(this);
	        this.formstoreId = '';
	        this.init();
	    }
	
	    brandNewslettercomponent.prototype.init = function () {
	        this.bind();
	    };
	
	    brandNewslettercomponent.prototype.bind = function () {
	        var _this = this;
	        if (_this.inputFieldElement) {
	            _this.inputFieldElement.addEventListener('blur', _this.validateInputField);
	            _this.inputFieldElement.addEventListener('focus', _this.validateInputFieldOnFocus);
	        }
	        if (_this.emailSubmitButton) {
	            _this.emailSubmitButton.addEventListener('click', _this.validateInputField);
	            analytics.bind(_this.emailSubmitButton, [{
	                functionName: 'analyticsBrandNewsLetterSubmit',
	                event: 'click'
	            }]);
	        }
	    };
	
	    brandNewslettercomponent.prototype.validateInputField = function (evt) {
	        var _this = this;
	
	        if (_this.inputFieldElement && _this.inputFieldElement.value === '') {
	            Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
	            Utils.addClass(_this.emailErrormsg, 'navfooter-brand-newsletter-signup-errormsg-none');
	            Utils.removeClass(_this.alertIcon, 'navfooter-alertdiv');
	            _this.inputFieldElement.removeEventListener('input', _this.validateInputField);
	            evt.preventDefault();
	        } else {
	            if (/^[a-z\d._\+%&amp;\'\/=~$*?!`\-]+@[a-z0-9.\-]+\.[a-z]{2,24}$/i.test(_this.inputFieldElement.value)) {
	                Utils.addClass(_this.emailErrormsg, 'navfooter-brand-newsletter-signup-errormsg-none');
	                Utils.removeClass(_this.alertIcon, 'navfooter-alertdiv');
	                Utils.removeClass(_this.inputFieldElement, 'nav-footer--invalidemail');
	            } else {
	                Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
	                Utils.removeClass(_this.emailErrormsg, 'navfooter-brand-newsletter-signup-errormsg-none');
	                Utils.addClass(_this.alertIcon, 'navfooter-alertdiv');
	                _this.inputFieldElement.addEventListener('input', _this.validateInputField);
	                evt.preventDefault();
	            }
	        }
	    };
	
	    brandNewslettercomponent.prototype.validateInputFieldOnFocus = function () {
	        if (this.inputFieldElement.value === '' && Utils.hasClass(this.inputFieldElement, 'nav-footer--invalidemail')) {
	            Utils.removeClass(this.inputFieldElement, 'nav-footer--invalidemail');
	        }
	    };
	
	    return brandNewslettercomponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1), __webpack_require__(5), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, analytics, Constantvalues, Config) {
	
	    var slideliElements = 0,
	        positionValue,
	        position;
	    var setDirection,
	        activebubbleIndex,
	        direction,
	        timeoutForRemoveProduct = {},
	        removedItemCount = 0;
	    var CAROUSEL_ID;
	    var carouselInteractionId;
	    var totalNumberofSlides;
	    var productTcode;
	    var productcarouselinteractionId;
	    var scrollclicked = 0,
	        leftswiped = 0;
	    var carouselseenCount = 0;
	    var xDown = null;
	    var yDown = null;
	    var leftSwipeCount = 0;
	    var rightSwipeCount = 0;
	    function Carouseltemplate(el) {
	        this.carousel = el;
	    }
	
	    Carouseltemplate.prototype = {
	        init: function init() {
	            var recentlyviewedItemArray = this.carousel;
	            this.wrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
	            this.sliderpreviousbtn = document.querySelector('.navfooter-desktopcarousel__previousbtn');
	            this.slidernextbtn = document.querySelector('.navfooter-desktopcarousel__nextbtn');
	            this.slideIndex = 0;
	            this.pageTypeElement = document.getElementById('pageType');
	            if (this.pageTypeElement) {
	                CAROUSEL_ID = '#intid=carousel_FUNH_AT_RECENT_END_' + this.pageTypeElement.innerText;
	                carouselInteractionId = 'FUNH_AT_RECENT_END_' + this.pageTypeElement.innerText;
	            }
	            var template = '<li class="navfooter-desktopcarousel__slide-product">\n            <div class="navfooter-desktopcarousel__slide-productitem">\n            <div class="navfooter-desktopcarousel__slideproddetails">\n                <div class="navfooter-desktopcarousel__imagetiles">\n                    <a > <div class="navfooter-desktopcarousel__imagediv"><span><img\n                            src="" /></span>\n                </div>\n                <div class="navfooter-desktopcarousel__price"> \n                <span class="navfooter-desktopcarousel-pricedetails"></span>\n                <span class="navfooter-desktopcarousel-waspricediv"></span>\n                </div>\n                </a></div>\n                <a  href="javascript:void(0)"class="navfooter-desktopcarousel__remove" aria-label="remove">Remove</a>\n                </div>\n                <div class="navfooter-desktopcarousel__undowrapper"><span class="navfooter-desktopcarousel__undolabel">Item Removed</span>\n                <a href="javascript:void(0)" class="navfooter-desktopcarousel__undo">Undo</a></div>\n            </div>\n        </li>';
	            var sliderButtontemplate = '<button class="navfooter-desktopcarousel__page-button" tabindex="-1">\n            <span class="navfooter-desktopcarousel__page">\n                <span class="navfooter-desktopcarousel__slidenumber"></span>\n            </span>';
	
	            var brandNametemplate = '<div class="navfooter-desktopcarousel__brand">\n                <span></span>\n            </div>';
	
	            var productTitletemplate = '<div class="navfooter-desktopcarousel__title">\n                <span></span>\n            </div>';
	
	            for (var i = 0; i < recentlyviewedItemArray.length; i++) {
	                if (recentlyviewedItemArray[i].id !== '') {
	                    slideliElements++;
	                    this.wrapper.innerHTML += template;
	                    this.productwrapperli = document.querySelectorAll('.navfooter-desktopcarousel__slide-product-wrapper li');
	                    this.productImageTag = this.wrapper.getElementsByTagName('img');
	                    this.productImagehrefTag = this.productwrapperli[i].querySelector('.navfooter-desktopcarousel__imagetiles a');
	                    this.productpriceDetails = this.productwrapperli[i].querySelector('.navfooter-desktopcarousel__price .navfooter-desktopcarousel-pricedetails');
	                    this.productwaspriceDetails = this.productwrapperli[i].querySelector('.navfooter-desktopcarousel__price .navfooter-desktopcarousel-waspricediv');
	
	                    this.productwrapperli[i].setAttribute('id', recentlyviewedItemArray[i].id);
	                    this.productwrapperli[i].setAttribute('TCode', recentlyviewedItemArray[i].TCode);
	                    this.productImageTag[i].setAttribute('src', recentlyviewedItemArray[i].imageURL);
	                    this.productImageTag[i].setAttribute('data-src', recentlyviewedItemArray[i].imageURL);
	                    if (typeof CAROUSEL_ID !== 'undefined' && CAROUSEL_ID !== null && CAROUSEL_ID !== 'undefined') {
	                        this.imageurlwithanalytics = recentlyviewedItemArray[i].productURL + CAROUSEL_ID + '_' + recentlyviewedItemArray.length + '_' + (i + 1);
	                        this.productImagehrefTag.setAttribute('href', this.imageurlwithanalytics);
	                        this.productwrapperli[i].setAttribute('carouselInteractionId', carouselInteractionId + '_' + (i + 1));
	                    } else {
	                        this.productImagehrefTag.setAttribute('href', recentlyviewedItemArray[i].productURL);
	                    }
	                    if (recentlyviewedItemArray[i].SaleFlag === 'Y') {
	                        this.productpriceDetails.innerHTML = this.printPriceRange(recentlyviewedItemArray[i].priceRange);
	                        Utils.addClass(this.productpriceDetails, 'saleprice');
	                        this.productImagehrefTag.setAttribute('aria-label', recentlyviewedItemArray[i].name + ' ' + this.printPriceRange(recentlyviewedItemArray[i].priceRange));
	                    } else if (recentlyviewedItemArray[i].PromotionFlag === 'Y') {
	                        this.productpriceDetails.innerHTML = this.printPriceRange(recentlyviewedItemArray[i].PromotionalPriceRange);
	                        Utils.addClass(this.productpriceDetails, 'promotionalprice');
	                        this.productwaspriceDetails.innerHTML = this.printwasprice(recentlyviewedItemArray[i].priceRange);
	                        this.productImagehrefTag.setAttribute('aria-label', recentlyviewedItemArray[i].name + ' ' + 'Previous price ' + this.printwasprice(recentlyviewedItemArray[i].priceRange) + ' Current Price ' + this.printPriceRange(recentlyviewedItemArray[i].PromotionalPriceRange));
	                    } else {
	                        this.productpriceDetails.innerHTML = this.printPriceRange(recentlyviewedItemArray[i].priceRange);
	                        Utils.addClass(this.productpriceDetails, 'saleprice');
	                        this.productImagehrefTag.setAttribute('aria-label', recentlyviewedItemArray[i].name + ' ' + this.printPriceRange(recentlyviewedItemArray[i].priceRange));
	                    }
	
	                    if (recentlyviewedItemArray[i].Brand) {
	                        this.productImagehrefTag.innerHTML += brandNametemplate;
	                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__brand').setAttribute('aria-label', recentlyviewedItemArray[i].Brand);
	                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__brand span').innerText = recentlyviewedItemArray[i].Brand.toUpperCase();
	                    }
	
	                    if (recentlyviewedItemArray[i].name) {
	                        this.productImagehrefTag.innerHTML += productTitletemplate;
	                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__title').setAttribute('aria-label', recentlyviewedItemArray[i].name);
	                        this.productImagehrefTag.querySelector('.navfooter-desktopcarousel__title span').innerText = recentlyviewedItemArray[i].name;
	                    }
	
	                    if (recentlyviewedItemArray[i].rating) {
	                        this.ratingPercentage = parseFloat(recentlyviewedItemArray[i].rating) / 5 * 100;
	
	                        var productRatingtemplate = '<div class="navfooter-desktopcarousel__rating">\n                            <p class="star-rating">\n                                <span class="star-rating__base">\n                                    <svg aria-hidden="true" width="89" height="12" viewBox="0 0 61 11" xmlns="http://www.w3.org/2000/svg"\n                                        title="Star Rating">\n                                        <g>\n                                            <path\n                                                d="M2.101 11l.655-3.987L0 4.193l3.79-.584L5.512 0l1.723 3.644 3.79.584-2.757 2.819L8.923 11 5.512 9.11zM14.595 11l.655-3.987-2.756-2.82 3.79-.584L18.006 0l1.723 3.644 3.79.584-2.757 2.819.655 3.953-3.411-1.89zM27.09 11l.654-3.987-2.756-2.82 3.79-.584L30.5 0l1.723 3.644 3.789.584-2.756 2.819.655 3.953L30.5 9.11zM39.583 11l.655-3.987-2.756-2.82 3.79-.584L42.993 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89zM52.077 11l.655-3.987-2.756-2.82 3.79-.584L55.487 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89z">\n                                            </path>\n                                        </g>\n                                    </svg></span>\n                                    <span class="star-rating__filled"  style="width: calc(' + this.ratingPercentage + '%);">\n                                    <svg\n                                        aria-hidden="true" width="89" height="12" viewBox="0 0 61 11" xmlns="http://www.w3.org/2000/svg"\n                                        title="Star Rating">\n                                        <g>\n                                            <path\n                                                d="M2.101 11l.655-3.987L0 4.193l3.79-.584L5.512 0l1.723 3.644 3.79.584-2.757 2.819L8.923 11 5.512 9.11zM14.595 11l.655-3.987-2.756-2.82 3.79-.584L18.006 0l1.723 3.644 3.79.584-2.757 2.819.655 3.953-3.411-1.89zM27.09 11l.654-3.987-2.756-2.82 3.79-.584L30.5 0l1.723 3.644 3.789.584-2.756 2.819.655 3.953L30.5 9.11zM39.583 11l.655-3.987-2.756-2.82 3.79-.584L42.993 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89zM52.077 11l.655-3.987-2.756-2.82 3.79-.584L55.487 0l1.722 3.644 3.79.584-2.756 2.819.655 3.953-3.411-1.89z">\n                                            </path>\n                                        </g>\n                                    </svg>\n                                    </span>\n                                    <span class="acc__text">Average ratinging: ' + recentlyviewedItemArray[i].rating + ' out of 5</span>\n                            </p>\n                        </div>';
	                        if (this.ratingPercentage > 0) {
	                            this.productImagehrefTag.innerHTML += productRatingtemplate;
	                        }
	                    }
	                }
	            }
	            this.totalslideRequired = Math.ceil(slideliElements / 6);
	            totalNumberofSlides = this.totalslideRequired;
	            this.slidepageparentdiv = document.querySelector('.navfooter-desktopcarousel__bottomdiv');
	            this.slideproductItem = document.querySelectorAll('.navfooter-desktopcarousel__slide-productitem');
	            this.slideProductWrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
	            this.carouselHeadingElement = document.querySelector('.navfooter-recentlyviewed__heading');
	            this.bodyelement = document.querySelector('body');
	            if (this.totalslideRequired > 1) {
	                for (var btn = 1; btn <= this.totalslideRequired; btn++) {
	                    this.slidepageparentdiv.innerHTML += sliderButtontemplate;
	                    this.slidetext = this.slidepageparentdiv.querySelectorAll('.navfooter-desktopcarousel__slidenumber');
	                    this.slideBtn = this.slidepageparentdiv.querySelectorAll('.navfooter-desktopcarousel__page-button');
	                    this.slidetext[btn - 1].innerText = 'Slide ' + btn + ' ' + 'for recently viewed';
	                    this.slideBtn[btn - 1].setAttribute('id', btn);
	                }
	                Utils.addClass(this.sliderpreviousbtn, 'activatenavigatebtn');
	                Utils.addClass(this.slidernextbtn, 'activatenavigatebtn');
	                this.sliderpreviousbtn.addEventListener('click', this.previousSlideEvent.bind(this));
	                this.slidernextbtn.addEventListener('click', this.nextSlideEvent.bind(this));
	                /* inline style width to Li */
	                if ('1280' <= window.innerWidth && window.innerWidth < '1920') {
	                    for (var j = 0; j < this.slideproductItem.length; j++) {
	                        this.slideproductItem[j].style.width = (this.slideProductWrapper.offsetWidth - 112) / 6 + 'px';
	                    }
	                }
	                this.slidepageparentdiv.addEventListener('click', this.slidebind.bind(this));
	                this.activatebutton();
	            }
	            this.bindRemovefunction(recentlyviewedItemArray);
	            if (window && window.innerWidth >= '1280') {
	                this.bindswipefunction();
	            }
	            this.setCarouseIDfunction();
	            this.carouselOnloadAnalytics();
	            window.addEventListener('scroll', this.listenscrollEvent.bind(this));
	        },
	
	        bindRemovefunction: function bindRemovefunction(ele) {
	            var removeElementTag = this.wrapper.querySelectorAll('.navfooter-desktopcarousel__remove');
	            var undoWrapperTag = this.wrapper.querySelectorAll('.navfooter-desktopcarousel__undowrapper a');
	            for (var fn = 0; fn < ele.length; fn++) {
	                if (ele[fn].id !== '') {
	                    removeElementTag[fn].addEventListener('click', this.removeProductHandler.bind(this));
	                    undoWrapperTag[fn].addEventListener('click', this.undoProductHandler.bind(this));
	                }
	            }
	        },
	        slidebind: function slidebind(event) {
	
	            if (Utils.hasClass(event.target, 'navfooter-desktopcarousel__page-button') && !Utils.hasClass(event.target, 'activatebubblebtn')) {
	                setDirection = this.getDirection(event);
	            }
	            if (setDirection === 'fwd') {
	                this.nextSlideEventbtnclick(event.target.getAttribute('id') - 1);
	            }
	            if (setDirection === 'bwd') {
	                this.previousEventbtnclick(event.target.getAttribute('id') - 1);
	            }
	        },
	        getDirection: function getDirection(event) {
	            var navfooterslidepagebtn = document.querySelectorAll('.navfooter-desktopcarousel__page-button');
	            for (var slidepagebtn = 0; slidepagebtn < navfooterslidepagebtn.length; slidepagebtn++) {
	                if (navfooterslidepagebtn[slidepagebtn].classList.contains('activatebubblebtn')) {
	                    if (slidepagebtn > event.target.getAttribute('id') - 1) {
	                        setDirection = 'bwd'; //backward
	                        activebubbleIndex = slidepagebtn;
	                        return setDirection;
	                    } else if (slidepagebtn < event.target.getAttribute('id') - 1) {
	                        setDirection = 'fwd'; //forward
	                        activebubbleIndex = slidepagebtn;
	                        return setDirection;
	                    }
	                }
	            }
	        },
	        nextSlideEventbtnclick: function nextSlideEventbtnclick(elemCount) {
	            var _this = this;
	            elemCount ? _this.slideIndex = elemCount : false;
	            _this.isLastSlide() ? _this.disablenextbtn() : _this.enablePreviousbtn();
	            _this.slidercssfunction();
	            _this.activatebutton(setDirection);
	            if (this.totalslideRequired === 3) {
	                if (elemCount === 1) {
	                    leftSwipeCount++;
	                    rightSwipeCount = rightSwipeCount > 1 ? rightSwipeCount - 1 : rightSwipeCount;
	                } else if (elemCount === 2) {
	                    leftSwipeCount = leftSwipeCount + 2;
	                    rightSwipeCount = rightSwipeCount > 1 ? rightSwipeCount - 2 : rightSwipeCount;
	                }
	            } else {
	                leftSwipeCount++;
	                rightSwipeCount = rightSwipeCount > 1 ? rightSwipeCount - 1 : rightSwipeCount;
	            }
	            setTimeout(function () {
	                if (_this.bodyelement.classList.contains('bodyoverflow')) {
	                    _this.bodyelement.classList.remove('bodyoverflow');
	                }
	            }, 300);
	        },
	        previousEventbtnclick: function previousEventbtnclick(elemCount) {
	            var _this = this;
	            if (elemCount >= 0) {
	                _this.slideIndex = elemCount;
	            }
	            _this.isFirstSlide() ? _this.disablePreviousbtn() : _this.enablenextbtn();
	            this.slidercssfunction();
	            _this.activatebutton(setDirection);
	            if (this.totalslideRequired === 3) {
	                if (elemCount === 1) {
	                    rightSwipeCount++;
	                    leftSwipeCount = leftSwipeCount > 1 ? leftSwipeCount - 1 : leftSwipeCount;
	                } else if (elemCount === 0) {
	                    rightSwipeCount = rightSwipeCount + 2;
	                    leftSwipeCount = leftSwipeCount > 1 ? leftSwipeCount - 2 : leftSwipeCount;
	                }
	            } else {
	                rightSwipeCount++;
	                leftSwipeCount = leftSwipeCount > 1 ? leftSwipeCount - 1 : leftSwipeCount;
	            }
	
	            setTimeout(function () {
	                if (_this.bodyelement.classList.contains('bodyoverflow')) {
	                    _this.bodyelement.classList.remove('bodyoverflow');
	                }
	            }, 300);
	        },
	        printwasprice: function printwasprice(productwasPriceRangeDetails) {
	            if (Config && Config.storeId === Constantvalues.ukId) {
	                return productwasPriceRangeDetails[0] !== productwasPriceRangeDetails[1] ? Constantvalues.currencyUk + productwasPriceRangeDetails[0] + ' - ' + Constantvalues.currencyUk + productwasPriceRangeDetails[1] : Constantvalues.currencyUk + productwasPriceRangeDetails[0];
	            } else if (Config && Config.storeId === Constantvalues.ieId) {
	                return productwasPriceRangeDetails[0] !== productwasPriceRangeDetails[1] ? Constantvalues.currencyIe + productwasPriceRangeDetails[0] + ' - ' + Constantvalues.currencyIe + productwasPriceRangeDetails[1] : Constantvalues.currencyIe + productwasPriceRangeDetails[0];
	            }
	        },
	        printPriceRange: function printPriceRange(productPriceRangeDetails) {
	            if (Config && Config.storeId === Constantvalues.ukId) {
	                if (productPriceRangeDetails[0] !== productPriceRangeDetails[1]) {
	                    var productpriceinitial = productPriceRangeDetails[0].split('.');
	                    var productpricefinal = productPriceRangeDetails[1].split('.');
	                    if (productpriceinitial[1] === '00' && productpricefinal[1] === '00') {
	                        return Constantvalues.currencyUk + productpriceinitial[0] + ' - ' + Constantvalues.currencyUk + productpricefinal[0];
	                    } else if (productpriceinitial[1] === '00' && productpricefinal[1] !== '00') {
	                        return Constantvalues.currencyUk + productpriceinitial[0] + ' - ' + Constantvalues.currencyUk + productPriceRangeDetails[1];
	                    } else if (productpriceinitial[1] !== '00' && productpricefinal[1] === '00') {
	                        return Constantvalues.currencyUk + productPriceRangeDetails[0] + ' - ' + Constantvalues.currencyUk + productpricefinal[0];
	                    } else {
	                        return Constantvalues.currencyUk + productPriceRangeDetails[0] + ' - ' + Constantvalues.currencyUk + productPriceRangeDetails[1];
	                    }
	                } else {
	                    var singleproductprice = productPriceRangeDetails[0].split('.');
	                    if (singleproductprice[1] === '00') {
	                        return Constantvalues.currencyUk + singleproductprice[0];
	                    } else {
	                        return Constantvalues.currencyUk + productPriceRangeDetails[0];
	                    }
	                }
	            } else if (Config && Config.storeId === Constantvalues.ieId) {
	                return productPriceRangeDetails[0] !== productPriceRangeDetails[1] ? Constantvalues.currencyIe + productPriceRangeDetails[0] + ' - ' + Constantvalues.currencyIe + productPriceRangeDetails[1] : Constantvalues.currencyIe + productPriceRangeDetails[0];
	            }
	        },
	        previousSlideEvent: function previousSlideEvent() {
	            var _this = this;
	            direction = 'Backward';
	            _this.slideIndex -= 1;
	            _this.isFirstSlide() ? _this.disablePreviousbtn() : _this.enablenextbtn();
	            this.slidercssfunction();
	            this.activatebutton(direction);
	            rightSwipeCount++;
	            leftSwipeCount = leftSwipeCount > 1 ? leftSwipeCount - 1 : leftSwipeCount;
	            setTimeout(function () {
	                if (_this.bodyelement.classList.contains('bodyoverflow')) {
	                    _this.bodyelement.classList.remove('bodyoverflow');
	                }
	            }, 300);
	        },
	        nextSlideEvent: function nextSlideEvent() {
	            var _this = this;
	            direction = 'Forward';
	            _this.slideIndex += 1;
	            _this.isLastSlide() ? _this.disablenextbtn() : _this.enablePreviousbtn();
	            this.slidercssfunction();
	            this.activatebutton(direction);
	            this.scrollrightclickAnalytics();
	            leftSwipeCount++;
	            rightSwipeCount = rightSwipeCount > 1 ? rightSwipeCount - 1 : rightSwipeCount;
	            setTimeout(function () {
	                if (_this.bodyelement.classList.contains('bodyoverflow')) {
	                    _this.bodyelement.classList.remove('bodyoverflow');
	                }
	            }, 300);
	        },
	        activatebutton: function activatebutton(direction) {
	            var btnlist = document.querySelectorAll('.navfooter-desktopcarousel__page-button');
	            Utils.addClass(btnlist[this.slideIndex], 'activatebubblebtn');
	            if (direction === 'Forward') {
	                Utils.hasClass(btnlist[this.slideIndex - 1], 'activatebubblebtn') ? Utils.removeClass(btnlist[this.slideIndex - 1], 'activatebubblebtn') : false;
	                direction = '';
	            } else if (direction === 'Backward') {
	                Utils.hasClass(btnlist[this.slideIndex + 1], 'activatebubblebtn') ? Utils.removeClass(btnlist[this.slideIndex + 1], 'activatebubblebtn') : false;
	                direction = '';
	            }
	            if (setDirection === 'fwd' && activebubbleIndex >= 0) {
	                Utils.hasClass(btnlist[activebubbleIndex], 'activatebubblebtn') ? Utils.removeClass(btnlist[activebubbleIndex], 'activatebubblebtn') : false;
	                setDirection = '';
	            } else if (setDirection === 'bwd' && activebubbleIndex >= 0) {
	                Utils.hasClass(btnlist[activebubbleIndex], 'activatebubblebtn') ? Utils.removeClass(btnlist[activebubbleIndex], 'activatebubblebtn') : false;
	                setDirection = '';
	            }
	        },
	        isLastSlide: function isLastSlide() {
	            if (this.slideIndex === this.totalslideRequired - 1) {
	                return true;
	            } else {
	                return false;
	            }
	        },
	        isFirstSlide: function isFirstSlide() {
	            if (this.slideIndex === 0) {
	                return true;
	            } else {
	                return false;
	            }
	        },
	        disablePreviousbtn: function disablePreviousbtn() {
	            this.sliderpreviousbtn.setAttribute('aria-disabled', 'true');
	            this.sliderpreviousbtn.setAttribute('disabled', 'true');
	            this.slidernextbtn.getAttribute('aria-disabled') ? this.slidernextbtn.setAttribute('aria-disabled', 'false') : false;
	            this.slidernextbtn.getAttribute('disabled') ? this.slidernextbtn.removeAttribute('disabled') : false;
	        },
	        enablenextbtn: function enablenextbtn() {
	            this.slidernextbtn.setAttribute('aria-disabled', 'false');
	            this.slidernextbtn.getAttribute('disabled') ? this.slidernextbtn.removeAttribute('disabled') : false;
	        },
	        disablenextbtn: function disablenextbtn() {
	            this.slidernextbtn.setAttribute('aria-disabled', 'true');
	            this.slidernextbtn.setAttribute('disabled', 'true');
	            this.sliderpreviousbtn.getAttribute('aria-disabled') ? this.sliderpreviousbtn.setAttribute('aria-disabled', 'false') : false;
	            this.sliderpreviousbtn.getAttribute('disabled') ? this.sliderpreviousbtn.removeAttribute('disabled') : false;
	        },
	        enablePreviousbtn: function enablePreviousbtn() {
	            this.sliderpreviousbtn.setAttribute('aria-disabled', 'false');
	            this.sliderpreviousbtn.getAttribute('disabled') ? this.sliderpreviousbtn.removeAttribute('disabled') : false;
	        },
	        slidercssfunction: function slidercssfunction() {
	            if ('1280' <= window.innerWidth && window.innerWidth < '1920') {
	                position = this.slideIndex * (this.slideProductWrapper.offsetWidth - 16);
	                positionValue = 'translateX(-' + position + 'px)';
	                this.slideProductWrapper.style.transform = positionValue;
	            } else if (window.innerWidth >= '1920') {
	                position = this.slideIndex * this.slideProductWrapper.offsetWidth;
	                positionValue = 'translateX(-' + position + 'px)';
	                this.slideProductWrapper.style.transform = positionValue;
	            }
	        },
	        undoProductHandler: function undoProductHandler(event) {
	            event.preventDefault();
	            var element = event.currentTarget;
	            var parentElement = element.parentNode;
	            var grandParentElement = parentElement.parentNode.parentNode;
	            var productId = grandParentElement.getAttribute('id');
	            productTcode = grandParentElement.getAttribute('tcode');
	            productcarouselinteractionId = grandParentElement.getAttribute('carouselinteractionid');
	            clearTimeout(timeoutForRemoveProduct[productId]);
	            parentElement.style.display = 'none';
	            parentElement.previousElementSibling.style.display = 'block';
	            setTimeout(function () {
	                parentElement.previousElementSibling.style.opacity = '1';
	            }, 10);
	            grandParentElement.style.display = 'block';
	            this.undoanalyticsfunction(productTcode, productcarouselinteractionId);
	        },
	
	        removeProductHandler: function removeProductHandler(event) {
	            var _this = this;
	            event.preventDefault();
	            var parentElement = event.currentTarget.parentNode;
	            var grandParentElement = parentElement.parentNode.parentNode;
	            var productId = grandParentElement.getAttribute('id');
	            productTcode = grandParentElement.getAttribute('tcode');
	            productcarouselinteractionId = grandParentElement.getAttribute('carouselinteractionid');
	            parentElement.style.opacity = '0';
	            setTimeout(function () {
	                styleUndoWrpperElm(parentElement, grandParentElement);
	                timeoutForRemoveProduct[productId] = setTimeout(function () {
	                    if (window.outerWidth >= 1280) {
	                        grandParentElement.style.width = '0' + 'px';
	                        grandParentElement.style.margin = '0' + 'px';
	                    } else {
	                        grandParentElement.style.flexBasis = '0' + 'px';
	                        grandParentElement.style.width = '0' + 'px';
	                        grandParentElement.style.margin = '0' + 'px';
	                    }
	                    grandParentElement.querySelector('.navfooter-desktopcarousel__undowrapper').style.opacity = '0';
	                    _this.removeProductFromDom(productId, grandParentElement, productTcode, productcarouselinteractionId);
	                }, 4000);
	            }, 500);
	            function styleUndoWrpperElm(parentElement, grandParentElement) {
	                var undoWrapperElm = grandParentElement.querySelector('.navfooter-desktopcarousel__undowrapper');
	                var topStyle = parentElement.clientHeight / 2 + 'px';
	                undoWrapperElm.style.opacity = '1';
	                undoWrapperElm.style.display = 'flex';
	                var marginLeftStyle = (parentElement.clientWidth - undoWrapperElm.clientWidth) / 2 + 'px';
	                undoWrapperElm.style.top = topStyle;
	                undoWrapperElm.style.marginLeft = marginLeftStyle;
	            }
	        },
	        removeProductFromDom: function removeProductFromDom(productId, grandParentElement, productTcode, productcarouselinteractionId) {
	            var _this = this;
	            var bubblebtnhtml = document.querySelectorAll('.navfooter-desktopcarousel__page-button');
	            setTimeout(function () {
	                var item = document.getElementById(productId);
	                grandParentElement.parentNode.removeChild(item);
	                removedItemCount++;
	                var CurrentNumberOfSlides = Math.ceil((slideliElements - removedItemCount) / 6);
	                _this.totalslideRequired = CurrentNumberOfSlides;
	                if (totalNumberofSlides - CurrentNumberOfSlides !== 0) {
	                    bubblebtnhtml[CurrentNumberOfSlides] ? bubblebtnhtml[CurrentNumberOfSlides].remove() : false;
	                    totalNumberofSlides -= 1;
	                }
	                _this.isLastSlide() ? _this.disablenextbtn() : false;
	                if (CurrentNumberOfSlides === _this.slideIndex) {
	                    _this.slideIndex--;
	                    _this.slidercssfunction();
	                    bubblebtnhtml[CurrentNumberOfSlides] ? bubblebtnhtml[CurrentNumberOfSlides].remove() : false;
	                    bubblebtnhtml[CurrentNumberOfSlides - 1] ? Utils.addClass(bubblebtnhtml[CurrentNumberOfSlides - 1], 'activatebubblebtn') : false;
	                    if (_this.isFirstSlide()) {
	                        bubblebtnhtml[CurrentNumberOfSlides - 1].remove();
	                        _this.sliderpreviousbtn.style.display = 'none';
	                        _this.slidernextbtn.style.display = 'none';
	                    }
	                }
	                if (_this.slideIndex === 0 && CurrentNumberOfSlides === 1) {
	                    _this.sliderpreviousbtn.style.display = 'none';
	                    _this.slidernextbtn.style.display = 'none';
	                    if (bubblebtnhtml[CurrentNumberOfSlides - 1]) {
	                        bubblebtnhtml[CurrentNumberOfSlides - 1].remove();
	                    }
	                }
	
	                if (CurrentNumberOfSlides === 0) {
	                    document.querySelector('.navfooter-recentlyviewContainer').style.display = 'none';
	                }
	                _this.removeProductFromAdobe(productId);
	                _this.removeanalyticsfunction(productTcode, productcarouselinteractionId);
	            }, 1000);
	        },
	        removeProductFromAdobe: function removeProductFromAdobe(productId) {
	            var _this = this;
	            var targetResponseTokens = {};
	            var pid; //eslint-disable-line no-unused-vars
	            if (window.targetResponseTokens && window.targetResponseTokens.length > 0) {
	                _this.removingProductIdFromParams(productId, targetResponseTokens);
	                window.adobe.target.getOffer({
	                    'mbox': 'target-global-mbox', 'params': targetResponseTokens,
	                    'success': function success(offer) {
	                        pid = productId; //eslint-disable-line no-unused-vars
	                        window.adobe.target.applyOffer({ 'mbox': 'target-global-mbox', 'offer': offer });
	                    },
	                    'error': function error(status, _error) {
	                        console.log('Error', status, _error); // eslint-disable-line no-console
	                    }
	                });
	            }
	        },
	        removingProductIdFromParams: function removingProductIdFromParams(productId, targetResponseTokens) {
	            var count = 1;
	            var _this = this;
	            var excludedProducts = window.targetResponseTokens[0]['profile.excludedProducts' + count];
	            var products = excludedProducts && excludedProducts !== '' && excludedProducts !== 'null' ? JSON.parse(excludedProducts) : [];
	            if (products.length > 15 && count < 5) {
	                targetResponseTokens['profile.excludedProducts' + count] = JSON.stringify(products);
	                count++;
	                return _this.removingProductIdFromParams(productId, targetResponseTokens, count);
	            } else {
	                if (products.length <= 15) {
	                    products.push(productId);
	                }
	            }
	            targetResponseTokens['profile.excludedProducts' + count] = JSON.stringify(products);
	            return targetResponseTokens;
	        },
	        removeanalyticsfunction: function removeanalyticsfunction(productTcode, productcarouselinteractionId) {
	            var carousel_interaction_id = productcarouselinteractionId; // eslint-disable-line camelcase
	            if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
	                // eslint-disable-line no-undef, camelcase
	                utag.link({ link_name: 'carousel:remove item', carousel_interaction_id: carousel_interaction_id, product_stroke: [productTcode], event_name: 'carousel_item_remove' }); // eslint-disable-line no-undef, camelcase
	            }
	        },
	        undoanalyticsfunction: function undoanalyticsfunction(productTcode, productcarouselinteractionId) {
	            if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
	                // eslint-disable-line no-undef, camelcase
	                utag.link({ link_name: 'carousel:undo remove item', carousel_interaction_id: productcarouselinteractionId, product_stroke: [productTcode], event_name: 'carousel_undo_item_remove' }); // eslint-disable-line no-undef, camelcase
	            }
	        },
	        scrollrightclickAnalytics: function scrollrightclickAnalytics() {
	            if (scrollclicked === 0) {
	                if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) {
	                    // eslint-disable-line no-undef, camelcase
	                    utag.link({ link_name: 'carousel:scroll click', event_name: 'carousel_scroll', carousel_id: window.setCarouselIdforAnalytics }); // eslint-disable-line no-undef, camelcase
	                }
	                scrollclicked++;
	            }
	        },
	        setCarouseIDfunction: function setCarouseIDfunction() {
	            var listofItem = document.querySelectorAll('.navfooter-desktopcarousel__slide-product');
	            var setCarouselIdforAnalytics;
	            for (var eachlistofItem = 0; eachlistofItem < listofItem.length; eachlistofItem++) {
	                if (eachlistofItem === listofItem.length - 1) {
	                    setCarouselIdforAnalytics = listofItem[eachlistofItem].getAttribute('carouselinteractionid');
	                    window.setCarouselIdforAnalytics = setCarouselIdforAnalytics;
	                }
	            }
	        },
	        carouselOnloadAnalytics: function carouselOnloadAnalytics() {
	            if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) {
	                // eslint-disable-line no-undef, camelcase
	                utag.link({ carousel_id: window.setCarouselIdforAnalytics, link_name: 'carousel:present', event_name: 'carousel_present' }); // eslint-disable-line no-undef, camelcase
	            }
	        },
	        listenscrollEvent: function listenscrollEvent() {
	            if (carouselseenCount === 0) {
	                var callseenfunction = this.isCarouselSeen(this.carouselHeadingElement);
	                if (callseenfunction) {
	                    this.callcarouselseenAnalytics();
	                    carouselseenCount++;
	                }
	            }
	        },
	        isCarouselSeen: function isCarouselSeen(el) {
	            if (el) {
	                var rect = el.getBoundingClientRect();
	                return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	            }
	        },
	        callcarouselseenAnalytics: function callcarouselseenAnalytics() {
	            if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) {
	                // eslint-disable-line no-undef, camelcase
	                utag.link({ carousel_id: window.setCarouselIdforAnalytics, event_name: 'carousel_seen', link_name: 'carousel:seen' }); // eslint-disable-line no-undef, camelcase
	            }
	        },
	        swipeLeftAnalyticsfunction: function swipeLeftAnalyticsfunction() {
	            if (leftswiped === 0) {
	                if (typeof utag !== 'undefined' && typeof utag.link === 'function' && window && window.setCarouselIdforAnalytics) {
	                    // eslint-disable-line no-undef, camelcase
	                    utag.link({ link_name: 'carousel:scroll swipe', event_name: 'carousel_scroll', carousel_id: window.setCarouselIdforAnalytics }); // eslint-disable-line no-undef, camelcase
	                }
	                leftswiped++;
	            }
	        },
	        bindswipefunction: function bindswipefunction() {
	            var carouselProductWrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
	            carouselProductWrapper.addEventListener('touchstart', this.handleTouchStart.bind(this), false);
	            carouselProductWrapper.addEventListener('touchmove', this.handleTouchMove.bind(this), false);
	        },
	        getTouches: function getTouches(evt) {
	            return evt.touches || evt.originalEvent.touches;
	        },
	        handleTouchStart: function handleTouchStart(evt) {
	            var firstTouch = this.getTouches(evt)[0];
	            xDown = firstTouch.clientX;
	            yDown = firstTouch.clientY;
	        },
	        handleTouchMove: function handleTouchMove(evt) {
	            if (!xDown || !yDown) {
	                return;
	            }
	
	            var xUp = evt.touches[0].clientX;
	            var yUp = evt.touches[0].clientY;
	
	            var xDiff = xDown - xUp;
	            var yDiff = yDown - yUp;
	
	            if (Math.abs(xDiff) > Math.abs(yDiff)) {
	                /*most significant*/
	                if (xDiff > 0) {
	                    /* left swipe */
	                    evt.preventDefault();
	                    evt.stopPropagation();
	                    if (leftSwipeCount < this.totalslideRequired && !this.isLastSlide()) {
	                        Utils.addClass(this.bodyelement, 'bodyoverflow');
	                        this.nextSlideEvent();
	                        this.swipeLeftAnalyticsfunction();
	                    }
	                } else {
	                    /* right swipe */
	                    evt.preventDefault();
	                    evt.stopPropagation();
	                    if (rightSwipeCount < this.totalslideRequired && !this.isFirstSlide()) {
	                        Utils.addClass(this.bodyelement, 'bodyoverflow');
	                        this.previousSlideEvent();
	                    }
	                }
	            }
	            xDown = null;
	            yDown = null;
	        }
	
	    };
	    return Carouseltemplate;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var MS_USER_COOKIE = 'MS_USER_COOKIE',
	        config = window.mnsHeaderConfig ? window.mnsHeaderConfig : {};
	
	    /**
	     * Returns logged in user status from MS_USER_COOKIE
	     * @returns {boolean} TRUE if user is logged in
	     */
	    function isUserLoggedIn() {
	        return getUserCookieValue() !== null;
	    }
	
	    /**
	     * Returns username from MS_USER_COOKIE
	     * @returns {string | null} username
	     */
	    function getUsername() {
	        var value = getUserCookieValue();
	
	        return value !== null ? value.split('_')[0] : null;
	    }
	
	    function getStoreIdSuffixCookieValue(patternStr) {
	        var cookieKey,
	            cookieVal,
	            cookiePattern = patternStr + '=',
	            storeAwareCookiePattern;
	
	        if (config.MS_MAKE_STORE_AWARE_COOKIE) {
	            // read store aware cookie
	            storeAwareCookiePattern = patternStr + '_' + config.storeId + '=';
	            cookieVal = getCookieValue(storeAwareCookiePattern);
	
	            if (cookieVal) {
	                return cookieVal;
	            }
	
	            // read existing cookie
	            cookieVal = getCookieValue(cookiePattern);
	
	            if (cookieVal) {
	                cookieKey = getCookieKey(cookiePattern);
	                setCookieWithOptions(cookieKey + '_' + config.storeId, cookieVal);
	            }
	
	            return cookieVal;
	        }
	
	        return getCookieValue(cookiePattern);
	    }
	
	    function setCookieWithOptions(key, value, options, raw, json) {
	        options = options ? options : {};
	        raw = raw ? raw : false;
	        json = json ? json : false;
	
	        if (typeof options.expires === 'number') {
	            var days = options.expires;
	            var date = new Date();
	            date.setDate(date.getDate() + days);
	            options.expires = date.toUTCString();
	        }
	
	        value = json ? JSON.stringify(value) : String(value);
	        value = raw ? value : encodeURIComponent(value);
	        var keyValue = encodeURIComponent(key) + '=' + value + ';';
	
	        var optionsString = Object.keys(options).map(function (option) {
	            if (option === 'Secure') {
	                return option;
	            }
	            return option + '=' + options[option];
	        }).join(';');
	
	        return document.cookie = keyValue + ' ' + optionsString;
	    }
	
	    function getCookieKey(patternStr) {
	        var pattern = new RegExp(patternStr + '[^;]+'),
	            matches = document.cookie.match(pattern);
	        return matches && matches[0] ? matches[0].split('=')[0] : null;
	    }
	
	    function getCookieValue(patternStr) {
	        var pattern = new RegExp(patternStr + '[^;]+'),
	            matches = document.cookie.match(pattern);
	
	        return matches && matches[0] ? matches[0].split('=')[1] : null;
	    }
	
	    function getUserCookieValue() {
	        return getStoreIdSuffixCookieValue(MS_USER_COOKIE);
	    }
	
	    // service API
	    return {
	        isUserLoggedIn: isUserLoggedIn,
	        getUsername: getUsername,
	        getCookieValue: getCookieValue,
	        getUserLoginCookieValue: getUserCookieValue
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, analytics) {
	
	    function newsLettercomponent() {
	        this.inputFieldElement = document.querySelector('.navfooter-email');
	        this.formElementParms = document.querySelectorAll('.navfooter-formparms');
	        this.emailErrormsg = document.querySelector('.navfooter-errormsg');
	        this.alertIcon = document.querySelector('.nav-footer-alertdiv');
	        this.emailSubmitButton = document.querySelector('.navfooter-sign--button');
	        this.hoverMediaIcons = document.querySelectorAll('.navfooter-socialicons a img');
	        this.validateInputfield = this.validateInputfield.bind(this);
	        this.validateInputfieldonfocus = this.validateInputfieldonfocus.bind(this);
	        this.changeImagesrc = this.changeImagesrc.bind(this);
	        this.formstoreId = '';
	        this.init();
	    }
	
	    newsLettercomponent.prototype.init = function () {
	        this.bind();
	    };
	
	    newsLettercomponent.prototype.bind = function () {
	        var _this = this;
	        if (_this.inputFieldElement) {
	            _this.inputFieldElement.addEventListener('blur', _this.validateInputfield);
	            _this.inputFieldElement.addEventListener('focus', _this.validateInputfieldonfocus);
	        }
	        if (_this.emailSubmitButton) {
	            _this.emailSubmitButton.addEventListener('click', _this.validateInputfield);
	        }
	        for (var i = 0; i < _this.hoverMediaIcons.length; i++) {
	            _this.hoverMediaIcons[i].addEventListener('mouseover', _this.changeImagesrc);
	            _this.hoverMediaIcons[i].addEventListener('mouseout', _this.changeImagesrc);
	        }
	
	        if (_this.emailSubmitButton) {
	            analytics.bind(_this.emailSubmitButton, [{
	                functionName: 'analyticsNewsLetterInputError',
	                event: 'click'
	            }]);
	        }
	        if (_this.inputFieldElement) {
	            analytics.bind(_this.inputFieldElement, [{
	                functionName: 'analyticsNewsLetterInput',
	                event: 'focus'
	            }]);
	        }
	    };
	
	    newsLettercomponent.prototype.validateInputfield = function (evt) {
	        var _this = this;
	
	        if (_this.inputFieldElement && _this.inputFieldElement.value === '') {
	            Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
	            Utils.addClass(_this.emailErrormsg, 'navfooter-errormsg-none');
	            Utils.removeClass(_this.alertIcon, 'nav-footer-alertdivblock');
	            _this.inputFieldElement.removeEventListener('input', _this.validateInputfield);
	            evt.preventDefault();
	        } else {
	            if (/^[a-z\d._\+%&amp;\'\/=~$*?!`\-]+@[a-z0-9.\-]+\.[a-z]{2,24}$/i.test(_this.inputFieldElement.value)) {
	                Utils.addClass(_this.emailErrormsg, 'navfooter-errormsg-none');
	                Utils.removeClass(_this.alertIcon, 'nav-footer-alertdivblock');
	                Utils.removeClass(_this.inputFieldElement, 'nav-footer--invalidemail');
	                if (evt.type === 'click') {
	                    document.querySelector('.navfooter-newsletterformelement').action += '&footerid=' + window.btoa(this.inputFieldElement.value);
	                }
	            } else {
	                Utils.addClass(_this.inputFieldElement, 'nav-footer--invalidemail');
	                Utils.removeClass(_this.emailErrormsg, 'navfooter-errormsg-none');
	                Utils.addClass(_this.alertIcon, 'nav-footer-alertdivblock');
	                _this.inputFieldElement.addEventListener('input', _this.validateInputfield);
	                evt.preventDefault();
	            }
	        }
	    };
	
	    newsLettercomponent.prototype.validateInputfieldonfocus = function () {
	        if (this.inputFieldElement.value === '' && Utils.hasClass(this.inputFieldElement, 'nav-footer--invalidemail')) {
	            Utils.removeClass(this.inputFieldElement, 'nav-footer--invalidemail');
	        }
	    };
	
	    newsLettercomponent.prototype.changeImagesrc = function (evt) {
	        var hoverimagesrc = evt.target.getAttribute('src');
	        evt.target.src = evt.target.getAttribute('data-originalsrc');
	        evt.target.setAttribute('data-originalsrc', hoverimagesrc);
	    };
	
	    return newsLettercomponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    function pageSpecificComponent() {
	        this.pageType = document.getElementById('pageType');
	        this.pagetypefunction = this.pagetypefunction.bind(this);
	        this.pageComponentOff = this.pageComponentOff.bind(this);
	        this.init();
	    }
	
	    pageSpecificComponent.prototype.init = function () {
	        var pageTypeElement = this.pagetypefunction();
	        window.recentlyviewedEnabled = 'true';
	        if (pageTypeElement && window.footerComponentSwitch) {
	            var featureSwitchElements = window.footerComponentSwitch[pageTypeElement];
	        }
	        if (featureSwitchElements) {
	            this.pageComponentOff(featureSwitchElements);
	        }
	    };
	    pageSpecificComponent.prototype.pagetypefunction = function () {
	        if (this.pageType) {
	            var pageTypeText = this.pageType.innerText;
	            return pageTypeText;
	        } else {
	            var pageUrlArray = window.location.pathname.split('/');
	            for (var i = 0; i < pageUrlArray.length; i++) {
	                switch (pageUrlArray[i]) {
	                    case 'c':
	                    case 's':
	                        return 'STATIC';
	                    case 'p':
	                        return 'PDP';
	                }
	            }
	        }
	    };
	
	    pageSpecificComponent.prototype.pageComponentOff = function (featureSwitchElements) {
	        for (var Elements in featureSwitchElements) {
	            if (featureSwitchElements.hasOwnProperty(Elements)) {
	                var pagespecificcomponentDiv = document.getElementById(Elements);
	                if (featureSwitchElements[Elements] === false && pagespecificcomponentDiv) {
	                    pagespecificcomponentDiv.style.display = 'none';
	                }
	                if (Elements === 'recentlyviewedEnable' && featureSwitchElements[Elements] === false) {
	                    window.recentlyviewedEnabled = 'false';
	                }
	            }
	        }
	    };
	
	    return pageSpecificComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1), __webpack_require__(5), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, analytics, Constantvalues, Config, Carouseltemplate) {
	    var retryTime = 100;
	    var MAX_RETRIES = 30;
	    var retries = 0;
	
	    function recentlyviewedcomponent() {
	        this.getwindowData = setInterval(this.checkwindowData.bind(this), retryTime);
	    }
	
	    recentlyviewedcomponent.prototype = {
	        checkwindowData: function checkwindowData() {
	            var _this = this;
	            if (window.targetRecommendations || retries > MAX_RETRIES) {
	                clearInterval(_this.getwindowData);
	                if (!window.targetRecommendations) {
	                    return;
	                }
	                if (window.targetRecommendations.recent && window.recentlyviewedEnabled === 'true') {
	                    document.querySelector('.navfooter-recentlyviewed').style.display = 'block';
	                    _this.generaterecentlyviewedtemplate(window.targetRecommendations.recent);
	                }
	            } else {
	                retries++;
	            }
	        },
	        generaterecentlyviewedtemplate: function generaterecentlyviewedtemplate(recentlyviewedItem) {
	            this.el = recentlyviewedItem.recommendedProducts;
	            new Carouseltemplate(this.el).init();
	        }
	    };
	    return recentlyviewedcomponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(16)
	
	module.exports = forEach
	
	var toString = Object.prototype.toString
	var hasOwnProperty = Object.prototype.hasOwnProperty
	
	function forEach(list, iterator, context) {
	    if (!isFunction(iterator)) {
	        throw new TypeError('iterator must be a function')
	    }
	
	    if (arguments.length < 3) {
	        context = this
	    }
	    
	    if (toString.call(list) === '[object Array]')
	        forEachArray(list, iterator, context)
	    else if (typeof list === 'string')
	        forEachString(list, iterator, context)
	    else
	        forEachObject(list, iterator, context)
	}
	
	function forEachArray(array, iterator, context) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            iterator.call(context, array[i], i, array)
	        }
	    }
	}
	
	function forEachString(string, iterator, context) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        iterator.call(context, string.charAt(i), i, string)
	    }
	}
	
	function forEachObject(object, iterator, context) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            iterator.call(context, object[k], k, object)
	        }
	    }
	}


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(20)
	  , forEach = __webpack_require__(15)
	  , isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    }
	
	module.exports = function (headers) {
	  if (!headers)
	    return {}
	
	  var result = {}
	
	  forEach(
	      trim(headers).split('\n')
	    , function (row) {
	        var index = row.indexOf(':')
	          , key = trim(row.slice(0, index)).toLowerCase()
	          , value = trim(row.slice(index + 1))
	
	        if (typeof(result[key]) === 'undefined') {
	          result[key] = value
	        } else if (isArray(result[key])) {
	          result[key].push(value)
	        } else {
	          result[key] = [ result[key], value ]
	        }
	      }
	  )
	
	  return result
	}

/***/ },
/* 19 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 20 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(22);


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if (global.Promise == null) {
	  global.Promise = __webpack_require__(24);
	}
	
	if (Object.assign == null) {
	  Object.defineProperty(Object, 'assign', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: __webpack_require__(17)
	  });
	}
	
	module.exports = __webpack_require__(23);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()) || Function('return this')()))

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	 * Copyright 2015 Scott Brady
	 * MIT License
	 * https://github.com/scottbrady/xhr-promise/blob/master/LICENSE
	 */
	var ParseHeaders, XMLHttpRequestPromise;
	
	ParseHeaders = __webpack_require__(18);
	
	
	/*
	 * Module to wrap an XMLHttpRequest in a promise.
	 */
	
	module.exports = XMLHttpRequestPromise = (function() {
	  function XMLHttpRequestPromise() {}
	
	  XMLHttpRequestPromise.DEFAULT_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
	
	
	  /*
	   * XMLHttpRequestPromise.send(options) -> Promise
	   * - options (Object): URL, method, data, etc.
	   *
	   * Create the XHR object and wire up event handlers to use a promise.
	   */
	
	  XMLHttpRequestPromise.prototype.send = function(options) {
	    var defaults;
	    if (options == null) {
	      options = {};
	    }
	    defaults = {
	      method: 'GET',
	      data: null,
	      headers: {},
	      async: true,
	      username: null,
	      password: null,
	      withCredentials: false
	    };
	    options = Object.assign({}, defaults, options);
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var e, header, ref, value, xhr;
	        if (!XMLHttpRequest) {
	          _this._handleError('browser', reject, null, "browser doesn't support XMLHttpRequest");
	          return;
	        }
	        if (typeof options.url !== 'string' || options.url.length === 0) {
	          _this._handleError('url', reject, null, 'URL is a required parameter');
	          return;
	        }
	        _this._xhr = xhr = new XMLHttpRequest;
	        xhr.onload = function() {
	          var responseText;
	          _this._detachWindowUnload();
	          try {
	            responseText = _this._getResponseText();
	          } catch (_error) {
	            _this._handleError('parse', reject, null, 'invalid JSON response');
	            return;
	          }
	          return resolve({
	            url: _this._getResponseUrl(),
	            status: xhr.status,
	            statusText: xhr.statusText,
	            responseText: responseText,
	            headers: _this._getHeaders(),
	            xhr: xhr
	          });
	        };
	        xhr.onerror = function() {
	          return _this._handleError('error', reject);
	        };
	        xhr.ontimeout = function() {
	          return _this._handleError('timeout', reject);
	        };
	        xhr.onabort = function() {
	          return _this._handleError('abort', reject);
	        };
	        _this._attachWindowUnload();
	        xhr.open(options.method, options.url, options.async, options.username, options.password);
	        if (options.withCredentials) {
	          xhr.withCredentials = true;
	        }
	        if ((options.data != null) && !options.headers['Content-Type']) {
	          options.headers['Content-Type'] = _this.constructor.DEFAULT_CONTENT_TYPE;
	        }
	        ref = options.headers;
	        for (header in ref) {
	          value = ref[header];
	          xhr.setRequestHeader(header, value);
	        }
	        try {
	          return xhr.send(options.data);
	        } catch (_error) {
	          e = _error;
	          return _this._handleError('send', reject, null, e.toString());
	        }
	      };
	    })(this));
	  };
	
	
	  /*
	   * XMLHttpRequestPromise.getXHR() -> XMLHttpRequest
	   */
	
	  XMLHttpRequestPromise.prototype.getXHR = function() {
	    return this._xhr;
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._attachWindowUnload()
	   *
	   * Fix for IE 9 and IE 10
	   * Internet Explorer freezes when you close a webpage during an XHR request
	   * https://support.microsoft.com/kb/2856746
	   *
	   */
	
	  XMLHttpRequestPromise.prototype._attachWindowUnload = function() {
	    this._unloadHandler = this._handleWindowUnload.bind(this);
	    if (window.attachEvent) {
	      return window.attachEvent('onunload', this._unloadHandler);
	    }
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._detachWindowUnload()
	   */
	
	  XMLHttpRequestPromise.prototype._detachWindowUnload = function() {
	    if (window.detachEvent) {
	      return window.detachEvent('onunload', this._unloadHandler);
	    }
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._getHeaders() -> Object
	   */
	
	  XMLHttpRequestPromise.prototype._getHeaders = function() {
	    return ParseHeaders(this._xhr.getAllResponseHeaders());
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._getResponseText() -> Mixed
	   *
	   * Parses response text JSON if present.
	   */
	
	  XMLHttpRequestPromise.prototype._getResponseText = function() {
	    var responseText;
	    responseText = typeof this._xhr.responseText === 'string' ? this._xhr.responseText : '';
	    switch ((this._xhr.getResponseHeader('Content-Type') || '').split(';')[0]) {
	      case 'application/json':
	      case 'text/javascript':
	        responseText = JSON.parse(responseText + '');
	    }
	    return responseText;
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._getResponseUrl() -> String
	   *
	   * Actual response URL after following redirects.
	   */
	
	  XMLHttpRequestPromise.prototype._getResponseUrl = function() {
	    if (this._xhr.responseURL != null) {
	      return this._xhr.responseURL;
	    }
	    if (/^X-Request-URL:/m.test(this._xhr.getAllResponseHeaders())) {
	      return this._xhr.getResponseHeader('X-Request-URL');
	    }
	    return '';
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._handleError(reason, reject, status, statusText)
	   * - reason (String)
	   * - reject (Function)
	   * - status (String)
	   * - statusText (String)
	   */
	
	  XMLHttpRequestPromise.prototype._handleError = function(reason, reject, status, statusText) {
	    this._detachWindowUnload();
	    return reject({
	      reason: reason,
	      status: status || this._xhr.status,
	      statusText: statusText || this._xhr.statusText,
	      xhr: this._xhr
	    });
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._handleWindowUnload()
	   */
	
	  XMLHttpRequestPromise.prototype._handleWindowUnload = function() {
	    return this._xhr.abort();
	  };
	
	  return XMLHttpRequestPromise;
	
	})();


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {!function(t){"use strict";function e(t){if(t){var e=this;t(function(t){e.resolve(t)},function(t){e.reject(t)})}}function n(t,e){if("function"==typeof t.y)try{var n=t.y.call(i,e);t.p.resolve(n)}catch(o){t.p.reject(o)}else t.p.resolve(e)}function o(t,e){if("function"==typeof t.n)try{var n=t.n.call(i,e);t.p.resolve(n)}catch(o){t.p.reject(o)}else t.p.reject(e)}var r,i,c="fulfilled",u="rejected",s="undefined",f=function(){function e(){for(;n.length-o;){try{n[o]()}catch(e){t.console&&t.console.error(e)}n[o++]=i,o==r&&(n.splice(0,r),o=0)}}var n=[],o=0,r=1024,c=function(){if(typeof MutationObserver!==s){var t=document.createElement("div"),n=new MutationObserver(e);return n.observe(t,{attributes:!0}),function(){t.setAttribute("a",0)}}return typeof setImmediate!==s?function(){setImmediate(e)}:function(){setTimeout(e,0)}}();return function(t){n.push(t),n.length-o==1&&c()}}();e.prototype={resolve:function(t){if(this.state===r){if(t===this)return this.reject(new TypeError("Attempt to resolve promise with self"));var e=this;if(t&&("function"==typeof t||"object"==typeof t))try{var o=!0,i=t.then;if("function"==typeof i)return void i.call(t,function(t){o&&(o=!1,e.resolve(t))},function(t){o&&(o=!1,e.reject(t))})}catch(u){return void(o&&this.reject(u))}this.state=c,this.v=t,e.c&&f(function(){for(var o=0,r=e.c.length;r>o;o++)n(e.c[o],t)})}},reject:function(n){if(this.state===r){this.state=u,this.v=n;var i=this.c;i?f(function(){for(var t=0,e=i.length;e>t;t++)o(i[t],n)}):!e.suppressUncaughtRejectionError&&t.console&&t.console.log("You upset Zousan. Please catch rejections: ",n,n?n.stack:null)}},then:function(t,i){var u=new e,s={y:t,n:i,p:u};if(this.state===r)this.c?this.c.push(s):this.c=[s];else{var l=this.state,a=this.v;f(function(){l===c?n(s,a):o(s,a)})}return u},"catch":function(t){return this.then(null,t)},"finally":function(t){return this.then(t,t)},timeout:function(t,n){n=n||"Timeout";var o=this;return new e(function(e,r){setTimeout(function(){r(Error(n))},t),o.then(function(t){e(t)},function(t){r(t)})})}},e.resolve=function(t){var n=new e;return n.resolve(t),n},e.reject=function(t){var n=new e;return n.reject(t),n},e.all=function(t){function n(n,c){n&&"function"==typeof n.then||(n=e.resolve(n)),n.then(function(e){o[c]=e,r++,r==t.length&&i.resolve(o)},function(t){i.reject(t)})}for(var o=[],r=0,i=new e,c=0;c<t.length;c++)n(t[c],c);return t.length||i.resolve(o),i},typeof module!=s&&module.exports&&(module.exports=e),t.define&&t.define.amd&&t.define([],function(){return e}),t.Zousan=e,e.soon=f}("undefined"!=typeof global?global:this);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()) || Function('return this')(), __webpack_require__(4).setImmediate))

/***/ },
/* 25 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ])
});
;
//# sourceMappingURL=bundle.js.map


// WEBPACK FOOTER //
// /node_modules/@mands/mns-core-ui-footer/dist/templates/footer/bundle.js